export const SITE_URL = "https://joinkcn.com";

export type Crumb = { name: string; path: string };

/**
 * BreadcrumbList JSON-LD for a leaf page. Always pass the full trail
 * starting after Home, e.g. [{ name: "Results", path: "/results" }].
 */
export function breadcrumbSchema(trail: Crumb[]) {
  return {
    type: "application/ld+json",
    children: JSON.stringify({
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      itemListElement: [
        { "@type": "ListItem", position: 1, name: "Home", item: `${SITE_URL}/` },
        ...trail.map((c, i) => ({
          "@type": "ListItem",
          position: i + 2,
          name: c.name,
          item: `${SITE_URL}${c.path}`,
        })),
      ],
    }),
  };
}
